import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=9f070334"
import script from "./Usuario.vue?vue&type=script&lang=ts"
export * from "./Usuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports